/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEarAlert = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10.762 22H8v-2h2.6c1-.954 1.85-1.906 2.575-2.833zM24 22H13l1.888-3.776-.003.005L18.5 11zm-6.1-1.65h1.2v-1.1h-1.2zm0-2.2h1.2v-2.2h-1.2zM12 5.5c1.326 0 2.251.575 2.812 1.354.523.727.688 1.57.688 2.146h-2c0-.257-.085-.664-.311-.979-.19-.263-.515-.521-1.189-.521s-.999.258-1.188.521A1.797 1.797 0 0 0 10.5 9v2.675c.142.046.294.104.447.18.369.185.768.477 1.073.934.308.463.48 1.036.48 1.711s-.172 1.248-.48 1.71c-.305.458-.704.75-1.073.934a3.457 3.457 0 0 1-1.426.356h-.02l-.002-2h-.01l.026-.001a1.458 1.458 0 0 0 .538-.144.759.759 0 0 0 .303-.253c.066-.1.144-.277.144-.602s-.078-.502-.144-.602a.759.759 0 0 0-.303-.253 1.458 1.458 0 0 0-.538-.144l-.026-.001H8.5V9c0-.577.165-1.42.688-2.146C9.748 6.075 10.674 5.5 12 5.5z" />
        <path d="M12 2c2.69 0 4.487 1.045 5.586 2.444A6.58 6.58 0 0 1 18.6 6.3l-1.767 3.538C16.95 9.28 17 8.827 17 8.5c0-.738-.25-1.882-.986-2.82C15.313 4.79 14.109 4 12 4c-2.074 0-3.274.842-3.988 1.834C7.26 6.877 7 8.16 7 9H5c0-1.16.34-2.877 1.389-4.334C7.474 3.159 9.274 2 12 2z" />
      </g>
    </g>
  </Icon>
);
export { SvgEarAlert as EarAlert };
